/**
 * @generated SignedSource<<ee9e21d8a7a5bded94133a3625687732>>
 * @relayHash ff263d57c1476ada0866f11f9e83f1b8
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 059467b475232b7aee476bd09ff44fa2928d16c78ccce087b405121c42ae6021

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { ui_jiraCalendarQuery } from './ui_jiraCalendarQuery.graphql';

const node: PreloadableConcreteRequest<ui_jiraCalendarQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "059467b475232b7aee476bd09ff44fa2928d16c78ccce087b405121c42ae6021",
    "metadata": {},
    "name": "ui_jiraCalendarQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
